import VercelAuthPage from "../layouts/VercelAuthPage";
import SignupVercelForm from "../components/SignupForm";
import getErrorMessage from "../utils/getErrorMessage";
import { toast } from "react-toastify";
import { useState, useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import Link from "../components/Link";
import { SignupFormSubmitHandler } from "../components/SignupForm";
import { Box, Typography, CircularProgress, Stack } from "@mui/material";
import { AuthPageProps } from "./Signup";
import { doVercelSignup, linkVercelAccount } from "../clients/FixieApiClient";
import { trackEvent } from "../utils/trackEvent";

export default (props: AuthPageProps) => {
  const [isLoading, setIsLoading] = useState(false);
  const [linkRequestFailed, setLinkRequestFailed] = useState(false);
  const [hasTriedLinkingVercel, setHasTriedLinkingVercel] = useState(false);
  const [searchParams] = useSearchParams();
  const vercelCode = searchParams.get('code');
  const vercelConfigurationId = searchParams.get('configurationId');
  const vercelNextUrl = searchParams.get('next');

  useEffect(() => {
    const tryToLinkAccount = async () => {
      try {
        const response = await linkVercelAccount(
          vercelCode,
          vercelConfigurationId
        );

        if (response.ok) {
          trackEvent('link_vercel');
          window.location.href = vercelNextUrl || "/apps";
        } else {
          setLinkRequestFailed(true);
        }
      } catch (error) {
        setLinkRequestFailed(true);
      }
    };

    if (!hasTriedLinkingVercel) {
      setHasTriedLinkingVercel(true);
      tryToLinkAccount();
    }
  }, [hasTriedLinkingVercel, vercelCode, vercelConfigurationId, vercelNextUrl]);

  const onSubmit: SignupFormSubmitHandler = async (data) => {
    if (!isLoading) {
      try {
        setIsLoading(true);
        const response = await doVercelSignup({
          email: data.email,
          password: data.password,
          fullName: data.fullName,
          businessName: data.businessName,
          vercelCode,
          vercelConfigurationId
        });
        if (response.status === 201) {
          trackEvent('signup');
          await props.postLoginCallback();
          window.location.href = vercelNextUrl || "/apps";
        } else {
          const message = await getErrorMessage(response);
          toast.error(message || "Something went wrong");
        }
      } catch (error: any) {
        toast.error("Something went wrong");
      } finally {
        setIsLoading(false);
      }
    }
  }

  return (
    <VercelAuthPage>
      {linkRequestFailed ? (
        <Box>
          <Typography variant="h5">Create your Fixie account</Typography>
          <SignupVercelForm onSubmit={onSubmit} isLoading={isLoading} />
          <Box sx={{ textAlign: "center" }}>
            <Typography variant="body2">Already have a Fixie account? <Link to={`/login-vercel${window.location.search}`} variant="body2" style={{ textDecoration: "none" }}>
              Connect it
            </Link></Typography>
          </Box>
        </Box>
      ) : (
        <Stack>
          <CircularProgress />
        </Stack>
      )}
    </VercelAuthPage >
  )
};
